import React from 'react';
import { Link } from 'react-router-dom';
import './CoveredAreas.css';
import { regionsByGovernorate } from '../../data/areas';
import { targetedAreas } from '../../data/targetedAreas';
import { MapPin } from 'lucide-react';
import { toAreaSlug } from '../../utils/normalize';

const CoveredAreas = () => {
    return (
        <section className="covered-areas">
            <div className="covered-areas-container">
                <div className="covered-areas-header">
                    <h3 className="section-subtitle">تغطية شاملة</h3>
                    <h2 className="section-title">
                        المناطق التي <span className="highlight">نخدمها</span>
                    </h2>
                    <div className="title-divider">
                        <span className="star">★</span>
                        <span className="star">★</span>
                        <span className="star">★</span>
                        <span className="star">★</span>
                    </div>
                    <p className="covered-areas-description">
                        نقدم خدماتنا في جميع أنحاء مصر مع تغطية خاصة للمناطق التالية
                    </p>
                </div>

                <div className="areas-grid">
                    {regionsByGovernorate.map((area, index) => (
                        <Link
                            key={index}
                            to={`/areas/${encodeURIComponent(toAreaSlug(area.name))}/`}
                            className="area-card"
                        >
                            <div className="area-card-icon">
                                <MapPin color='var(--accent)' size={32} />
                            </div>
                            <h3 className="area-card-title">{area.name}</h3>
                            <div className="area-card-count">
                                {area.areas.length} منطقة فرعية
                            </div>
                            <span className="area-card-link">
                                عرض المناطق
                            </span>
                        </Link>
                    ))}
                </div>

                <div className="target-areas-section">
                    <h3 className="target-areas-title">أهم مناطق التغطية السريعة (تصل خلال 15 دقيقة)</h3>
                    <div className="target-areas-grid">
                        {targetedAreas.map((targetArea, idx) => (
                            <Link 
                                key={idx} 
                                to={`/areas/${encodeURIComponent(toAreaSlug(targetArea))}/`} 
                                className="target-area-link"
                            >
                                <span className="target-area-icon">📍</span>
                                ونش انقاذ {targetArea} <span className="target-area-discount">| خصم 50%</span>
                            </Link>
                        ))}
                    </div>
                </div>

                <div className="covered-areas-cta">
                    <Link to="/areas/" className="view-all-areas-btn">
                        عرض جميع المناطق
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default CoveredAreas;
